import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "login",
      component: () => import(/* webpackChunkName: "re" */ "./views/Login.vue")
    },
    /*{
      path: "/home",
      name: "home",
      component: Home
    },
    */
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/generate-qr",
      name: "qr",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/QR.vue")
    },
    {
      path: "/register/user",
      name: "newUser",
      component: () =>
        import(/* webpackChunkName: "re" */ "./views/RegisterUser.vue")
    },
    {
      path: "/menu",
      name: "menuEdit",
      component: () => import(/* webpackChunkName: "re" */ "./views/Menu.vue")
    },
    {
      path: "/cocina",
      name: "kitchen",
      component: () => import(/* webpackChunkName: "re" */ "./views/KanbanBoard.vue")
    },
    {
      path: "/f2a",
      name: "f2a",
      component: () => import(/* webpackChunkName: "re" */ "./views/f2a.vue")
    }
  ]
});
